module.exports = __webpack_public_path__ + "static/media/team-member2.74023b70.png";